/**
 * @generated SignedSource<<b9c2fa627c2bd0abce7d760880b45bf6>>
 * @relayHash 0cd91557d53b9b6139a042eb0a2f719f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d49f75291d05bb595819c924fa3d7507e7a6348ac01159c434e444569586104

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5d49f75291d05bb595819c924fa3d7507e7a6348ac01159c434e444569586104",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
